import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lumiron-list-item',
  templateUrl: 'list-item.component.html',
  styleUrl: './list-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ListItemComponent {
  public icon = input<string>('bi-plus-lg');
}
